import styled from 'styled-components';

export const FailedBlock = styled.div`
  .modal-body {
    display: flex;
    height: 40vh;
    flex-direction: column;
    justify-content: center;

    span {
      width: 100%;
    }
  }
`;
